function triggerConsentUpdateEvents() {

    const defaultConsents = sp.subConsents
    const spStorageKey = 'sp_consent'
    const storedConsent = JSON.parse(localStorage.getItem(spStorageKey))
    const consentCatMap = {
        Advertising: ['ad_storage', 'ad_user_data', 'ad_personalization'],
        Analytics: ['analytics_storage']
    }

    const shTrackingConsents = {
        "analytics":    false,
        "marketing":    false
    }

    defaultConsents?.forEach(con => {
        const consentCats = consentCatMap[con.ComplianceType] || []
        consentCats?.forEach(cat => {
            con.consentGiven && window.Shopify.analytics.publish('sp_category_consent_updated', {
                categoryName: cat,
                consentGiven: con.ConsentGiven
            })

            if (con.ComplianceType === 'Advertising') {
                shTrackingConsents.marketing = con.ConsentGiven
            }

            if (con.ComplianceType === 'Analytics') {
                shTrackingConsents.analytics = con.ConsentGiven
            }
        })
        con.PluginPreferences?.forEach(plugin => {
            let consentGranted = !plugin.IsBlockEnabled
            const storedConsentGroup = storedConsent.find(g => g.ComplianceType === con.ComplianceType)
            const storedPluginConsent = storedConsentGroup?.PluginPreferences?.find(p => p.ComplianceType === plugin.ComplianceType)
            if (storedPluginConsent !== undefined) {
                consentGranted = !storedPluginConsent.IsBlockEnabled
            }
            consentGranted && window.Shopify.analytics.publish('sp_consent_updated', {
                serviceName: plugin.ComplianceType,
                consentGiven: consentGranted
            })

            /*if (plugin.ComplianceType === 'Adroll' && consentGranted) {
                injectAdRollScript()
            }*/ 
        })
    })

    // This is for the shopify App Pixels (1st party / installed)
    window.Shopify.customerPrivacy.setTrackingConsent(
        shTrackingConsents,
        () => console.log("Consent captured")
    )
}

function injectAdRollScript() {
    const arScript = document.createElement('script')
    arScript.src = "https://assets1.adroll.com/shopify/latest/j/shopify_rolling_bootstrap_v2.js?adroll_adv_id=MOFSJUGYS5BMNBSDOYWRNN&adroll_pix_id=YYHGANFVCZFLXCIWSIUGQP&shop=zumbaapparel.myshopify.com"
    arScript.async = true
    document.head.appendChild(arScript)
}

function spInitialized(e) {
    setTimeout(triggerConsentUpdateEvents, 500)
}

if (Swivel.featureEnabled('SECURE_PRIVACY')) {
    window.Shopify.loadFeatures(
        [
            {
                name: 'consent-tracking-api',
                version: '0.1',
            },
        ],
        error => {
            if (error) {
                console.error('Error loading consent api', error)
                return
            }

            window.Shopify.customerPrivacy.currentVisitorConsent();
            window.Shopify.customerPrivacy.setTrackingConsent(
                {
                    "analytics":    false,
                    "marketing":    false,
                    "preferences":  true // Essential
                },
                () => console.log("Consent captured")
            )

            // 1. load secure privacy script
            const spScript = document.createElement('script')
            spScript.src = "https://app.secureprivacy.ai/script/682cd8faa32b1bf9b591e863.js"
            spScript.async = true
            document.head.appendChild(spScript)

            // 2. setup listeners
            window.addEventListener('sp_init', spInitialized)
            window.addEventListener('sp_cookie_banner_save', triggerConsentUpdateEvents)
            window.addEventListener('sp_privacy_banner_save', triggerConsentUpdateEvents)
        },
    )
}